import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SEO({ title, description, path = "" }) {
  const location = useLocation();
  const currentPath = path || location.pathname;
  const canonicalUrl = `https://learn.claritycirclehub.com${currentPath}`;

  useEffect(() => {
    // Update Title
    document.title = title;

    // Update Meta Description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", description);

    // Update Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);

    // Update Open Graph Tags
    const updateMeta = (property, value, isProperty = true) => {
      const selector = isProperty 
        ? `meta[property="${property}"]` 
        : `meta[name="${property}"]`;
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement("meta");
        if (isProperty) {
          element.setAttribute("property", property);
        } else {
          element.setAttribute("name", property);
        }
        document.head.appendChild(element);
      }
      element.setAttribute("content", value);
    };

    updateMeta("og:title", title);
    updateMeta("og:description", description);
    updateMeta("og:url", canonicalUrl);
    updateMeta("twitter:title", title, false);
    updateMeta("twitter:description", description, false);

  }, [title, description, canonicalUrl]);

  return null;
}
